import { GET_PROJECTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { BRAND_PENDING_DELIVERIES_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { project } from 'root/src/shared/descriptions/endpoints/recordTypes'
import { cardListType } from 'root/src/shared/constants/moduleTypes'
import { brandProjectsKey, projectDeliveryPendingKey } from 'root/src/shared/constants/keys'
import { BRAND_DARE_DELIVERY_DETAIL_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default {
	[BRAND_PENDING_DELIVERIES_MODULE_ID]: {
		moduleType: 'list',
		listType: cardListType,
		listPayload: {
			pageItemLength: 8,
			section: brandProjectsKey,
			subSection: projectDeliveryPendingKey,
		},
		recordType: project,
		endpointId: [GET_PROJECTS],
		listRouteId: BRAND_DARE_DELIVERY_DETAIL_ROUTE_ID,
		goTopButton: true,
	},
}
